import createSwitchingSideScroller from './createSwitchingSideScroller';

export default createSwitchingSideScroller('div', 'md');
